import { ToastContainer } from '../Toast/ToastContainer';
import { ConnectionBanner } from '../ConnectionBanner/ConnectionBanner';

export const NotificationHost = () => (
  <>
    <ConnectionBanner />
    <ToastContainer />
  </>
);

export default NotificationHost;
